// extracted by mini-css-extract-plugin
export var active = "_in-e";
export var blink = "_in-f";
export var dropDownSelector = "_in-5";
export var dropDownWrapper = "_in-4";
export var fakeCursor = "_in-d";
export var fontSizeButton = "_in-7";
export var formQuillEditor = "_in-0";
export var pressed = "_in-g";
export var qlBlank = "_in-1";
export var textFormattingToolbar = "_in-2";
export var textFormattingToolbarClosed = "_in-3";
export var textFormattingToolbarInline = "_in-6";
export var textToolbarOption = "_in-8";
export var toolbarCell = "_in-a";
export var toolbarCellCollapsed = "_in-b";
export var toolbarOptionHitArea = "_in-c";
export var toolbarOverflow = "_in-9";